import { AdminCMSApiRepository } from '@/app/repositories/api/AdminCMSApiRepository'
import {
  CreateAdminCMSRequestInterface,
  DeleteAdminCMSRequestInterface,
  UpdateAdminCMSInterface,
} from '@/data/payload/contracts/AdminRequest'
import { UserCMS } from '@/domain/entities/adminCMS'
import { injectable } from 'tsyringe'

@injectable()
export class AdminCMSPresenter {
  private repository: AdminCMSApiRepository

  constructor(repository: AdminCMSApiRepository) {
    this.repository = repository
  }

  public loadAdminRole(
    params: object
  ): Promise<Array<Record<string, number | string>>> {
    return this.repository.getAdminRole(params)
  }

  public loadAdminCMS(params: Object): Promise<UserCMS> {
    return this.repository.getAll(params)
  }

  public postAdminCMS(
    payload: CreateAdminCMSRequestInterface
  ): Promise<UserCMS> {
    return this.repository.create(payload)
  }

  public updateUser(
    payload: UpdateAdminCMSInterface,
    id: number
  ): Promise<UserCMS> {
    return this.repository.update(payload, id)
  }

  public deleteUser(payload: DeleteAdminCMSRequestInterface): Promise<UserCMS> {
    return this.repository.delete(payload)
  }
}
